import { Bar } from 'vue-chartjs';

export default {
    extends: Bar,
    props: {
        chartData: {
            type: Object,
            required: true
        },
        chartOptions: {
            type: Object,
            default: () => ({})
        }
    },
    mounted() {
        this.renderChart({
            labels: this.chartData.labels,
            datasets: this.chartData.datasets
        }, this.chartOptions);
    }
};